import Button from '@components/atoms/button';

type ChangePlanLinkProps = {
  isAppSubscription: boolean;
};

const ChangePlanLink = ({ isAppSubscription }: ChangePlanLinkProps) => {
  if (isAppSubscription) {
    return (
      <div className="font-semibold">
        Please manage your subscription via the mobile app.
      </div>
    );
  }
  return (
    <Button href="/member-upgrade" isLink variant="primary">
      Change Plan
    </Button>
  );
};

export default ChangePlanLink;
